import React from "react"
import { useModalContext } from "./ModalContext"

const ModalRoot = () => {
  const { components, props, hideModal } = useModalContext()
  const Component = components[0]

  return Component ? (
    <Component {...props[0]} visible onClose={hideModal} />
  ) : null
}

export { ModalRoot }
